import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';
import { chatKeyboardFocusVisible } from '../../styles/chatFocus';

export const Wrapper = styled.div<{ $isHeader?: boolean }>`
  position: ${({ $isHeader }) => ($isHeader ? 'relative' : 'absolute')};
  top: ${({ $isHeader }) => ($isHeader ? 'auto' : '0px')};
  right: ${({ $isHeader }) => ($isHeader ? 'auto' : toRem(12))};
`;
export const ActionsDropdown = styled.div<{ $isHeader?: boolean }>`
  position: absolute;
  ${({ $isHeader }) => ($isHeader ? 'top: 16px;' : 'top: 100%;')}
  ${({ $isHeader }) => ($isHeader ? 'left: 0;' : 'right: 0;')}
  background-color: ${baseVariables.color['base10']};
  color: ${baseVariables.color['base20']};
  border-radius: ${toRem(8)};
  z-index: 1000;
  min-width: 120px;
  overflow: hidden;
`;

export const NavListAction = styled.button`
  width: 100%;
  padding: ${toRem(8)} ${toRem(8)};
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font-size: ${toRem(14)};
  color: inherit;
  ${chatKeyboardFocusVisible}
`;

export const Action = styled.div`
  display: flex;
  align-items: center;
  gap: ${toRem(4)};
`;
